export default __webpack_public_path__ + "static/media/webilo-contact.6b6427e8.svg";